import * as React from "react";
const SvgFiRrTomato = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tomato_svg__a)">
      <path
        fill="#062147"
        d="M16.686 5.1c.952-.99 2.3-3.786.314-4.1a1 1 0 0 0-1 1c0 1.235-1.127 2.546-3 2.9V1a1 1 0 1 0-2 0v3.9C9.127 4.546 8 3.235 8 2a1 1 0 0 0-1-1c-1.983.312-.642 3.106.31 4.1A8.854 8.854 0 0 0 0 14c0 4.721 4.276 10 10 10h4c11.992.128 13.457-17.025 2.686-18.9M14 22h-4a8.32 8.32 0 0 1-8-8c-.052-4.611 4.3-8.172 8.5-6.648A4.47 4.47 0 0 1 7.757 9.03a1 1 0 0 0-.727 1.212c.74 2.132 4.745-.975 4.968-1.565.209.579 4.237 3.7 4.972 1.565a1 1 0 0 0-.728-1.212A4.47 4.47 0 0 1 13.5 7.352C23.917 4.589 25.406 21.99 14 22"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tomato_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTomato;
